import React, { useState, useEffect } from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';

import DataContainer from 'Components/UI/DataContainer';
import { displaySuccess, displayErrorMessage } from 'Helpers/FacetNotificationManager';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import DialogContent from './DialogContent';

const AccountTransferDialogContainer = (
  { accountTransferResource, closeModal },
) => {
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(null);
  const [accountName, setAccountName] = useState('');
  const canUpdateContributionYear = accountTransferResource?.relationship(fr.relationships.update.name);

  const {
    rootNodeProps, logEvent, logEventSuccess, logEventFailure,
  } = useEventTrackingLogEvent({ nodeName: 'Apex Account Transfer' });

  const fetchAccountName = async () => {
    try {
      // Fetch ACH Relationship
      if (accountTransferResource?.relationship(fr.relationships.achRelationship.name)) {
        try {
          const achRelationshipColl = await accountTransferResource?.relationship(fr.relationships.achRelationship.name)?.link('related').get();
          const achRelationshipRes = await achRelationshipColl.resources().head();
          setAccountName(achRelationshipRes.attr('nickname'));
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      }

      // Fetch Clearing House Account Relationship
      if (accountTransferResource?.relationship(fr.relationships.clearingHouseAccount.name)) {
        const chColl = await accountTransferResource?.relationship(fr.relationships.clearingHouseAccount.name)?.link('related').get();
        const chRelationshipRes = await chColl.resources().head();
        setAccountName(`****${chRelationshipRes.attr('accountNumber').substring(4)}`);
      }
    } catch (err) {
      setLoadingError(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAccountName();
  }, []);

  const cancelTransfer = async () => {
    logEvent('Clicked Cancel Transfer');

    try {
      await accountTransferResource.relationship('cancelTransfer').link('related')
        .Put(accountTransferResource.export(), {
          deprecatedAllowAlterOfRelation: true,
        });
      closeModal();
      displaySuccess('Successfully canceled transfer');
      logEventSuccess('Cancel transfer');
    } catch (err) {
      displayErrorMessage(err, 'An error occured while trying to cancel transfer');
      logEventFailure('Cancel transfer');
    }
  };

  const updateTransfer = async (iraContributionApplyToPriorYear) => {
    logEvent('Clicked Update Transfer');

    try {
      accountTransferResource.attr('iraContributionApplyToPriorYear', iraContributionApplyToPriorYear);
      await accountTransferResource.relationship(fr.relationships.update.name).link('related')
        .Put(accountTransferResource.export(), {
          deprecatedAllowAlterOfRelation: true,
        });
      closeModal();
      displaySuccess('Successfully updated transfer');
      logEventSuccess('Update ACH transfer');
    } catch (err) {
      displayErrorMessage(err, 'An error occured while trying to update transfer');
      logEventFailure('Update ACH transfer');
    }
  };

  return (
    <DataContainer
      loading={loading}
      loadingError={loadingError}
      ErrorListProps={{
        title: 'An error occurred while fetching account transfer.',
      }}
      {...rootNodeProps}
    >
      <DialogContent
        accountTransferResource={accountTransferResource}
        accountName={accountName}
        cancelTransfer={cancelTransfer}
        updateTransfer={canUpdateContributionYear ? updateTransfer : null}
      />,
    </DataContainer>
  );
};


AccountTransferDialogContainer.propTypes = {
  accountTransferResource: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default AccountTransferDialogContainer;
